/* eslint-disable no-multi-assign */
/* eslint-disable no-underscore-dangle */
// utils/loadTrackingScripts.js
import userflow from 'userflow.js';
import _ from 'lodash';
import configData from '../../config/loader';

export function loadMixPanel() {
  if (configData.companyName !== 'LICKLY') return null;
  if (window.location.hostname !== configData.productionHostname) return null;
  if (document.getElementById('mixpanel-script-loader') || window.mixpanel?.__SV) return null;

  // Inject official Mixpanel snippet as inline script
  const d = document;
  const s = d.createElement('script');
  s.id = 'mixpanel-script-loader';
  s.text = `
      (function(e,c){if(!c.__SV){var l,h;window.mixpanel=c;c._i=[];c.init=function(q,r,f){function t(d,a){var g=a.split(".");2==g.length&&(d=d[g[0]],a=g[1]);d[a]=function(){d.push([a].concat(Array.prototype.slice.call(arguments,0)))}}var b=c;"undefined"!==typeof f?b=c[f]=[]:f="mixpanel";b.people=b.people||[];b.toString=function(d){var a="mixpanel";"mixpanel"!==f&&(a+="."+f);d||(a+=" (stub)");return a};b.people.toString=function(){return b.toString(1)+".people (stub)"};l="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders start_session_recording stop_session_recording people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");for(h=0;h<l.length;h++)t(b,l[h]);var n="set set_once union unset remove delete".split(" ");b.get_group=function(){function d(p){a[p]=function(){b.push([g,[p].concat(Array.prototype.slice.call(arguments,0))])}}for(var a={},g=["get_group"].concat(Array.prototype.slice.call(arguments,0)),m=0;m<n.length;m++)d(n[m]);return a};c._i.push([q,r,f])};c.__SV=1.2;var k=e.createElement("script");k.type="text/javascript";k.async=!0;k.src="https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";var s=e.getElementsByTagName("script")[0];s.parentNode.insertBefore(k,s)}})(document,window.mixpanel||[]);

      mixpanel.init('${process.env.REACT_APP_MIXPANEL_TOKEN}', {
        autocapture: true,
        record_sessions_percent: 100,
      });
     
    `;
  d.head.appendChild(s);
  return s;
}

export function loadHubSpot() {
  if (window.location.hostname !== configData.productionHostname) return null;
  const d = document;
  const s = d.createElement('script');

  s.src =
    configData.companyName === 'LICKLY'
      ? '//js-na2.hs-scripts.com/244297432.js'
      : 'https://js.hs-scripts.com/3004731.js';
  s.id = 'hs-script-loader';
  s.defer = true;
  s.async = true;

  s.onload = () => {
    try {
      let accountData = null;
      const stored = localStorage.getItem('accountData');

      if (stored) {
        accountData = JSON.parse(stored);
        if (!accountData?.data?.email) throw new Error('No email found');
        const _hsq = (window._hsq = window._hsq || []);
        _hsq.push(['identify', { email: accountData.data.email }]);
        _hsq.push(['trackPageView']);
      } else {
        throw new Error('No accountData found');
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Failed to parse accountData from localStorage');
    }
  };

  d.getElementsByTagName('body')[0].appendChild(s);
  return s;
}

let lastIdentifiedUserflowId = null;

export function resetUserFlowIdentity() {
  lastIdentifiedUserflowId = null;
  if (!configData?.userFlowToken) return;
  try {
    userflow.reset();
  } catch {
    // Userflow may not be initialized (e.g. local dev)
  }
}

export function loadUserFlow(session) {
  if (configData.companyName !== 'LICKLY') return null;
  if (!configData?.userFlowToken || _.isEmpty(session)) return null;

  const accountData = JSON.parse(localStorage.getItem('accountData') || 'null');
  const rawId = session?.accountId ?? session?.account_id ?? accountData?.data?.id ?? null;
  const userId = rawId != null ? String(rawId) : null;
  if (!userId) return null;
  if (lastIdentifiedUserflowId === userId) return null;

  const planRaw = session?.workspace?.plan ?? null;
  const accountType =
    planRaw && typeof planRaw === 'object'
      ? planRaw.slug ?? planRaw.name ?? planRaw.code ?? ''
      : planRaw ?? '';

  const attributes = {
    name: `${accountData?.data?.firstName} ${accountData?.data?.lastName}` || '',
    email: session?.email,
    signed_up_at: null,
    account_type: String(accountType),
  };
  userflow.identify(userId, attributes);
  lastIdentifiedUserflowId = userId;
  return null;
}

export function loadUserFlowAfterAuth(session) {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  if (isMobile) return null;
  return loadUserFlow(session);
}

export function loadLiveAgent() {
  if (window.location.hostname !== 'dev-newui') return null;
  // if (configData.env !== 'PROD') return null;
  const d = document;
  const s = d.createElement('script');
  s.id = 'live-agent-script-loader';
  s.text = `
             (function (d, src, c) { var t = d.scripts[d.scripts.length - 1], s = d.createElement('script'); s.id = 'la_x2s6df8d'; s.defer = true; s.src = src; s.onload = s.onreadystatechange = function () { var rs = this.readyState; if (rs && (rs != 'complete') && (rs != 'loaded')) { return; } c(this); }; t.parentElement.insertBefore(s, t.nextSibling); })(document,
                  'https://radai.ladesk.com/scripts/track.js',
                  function (e) { LiveAgent.createButton('56z63jzy', e); });
        `;
  d.getElementsByTagName('body')[0].appendChild(s);
  return s;
}
